class Export {
  static PDF (self, INFO) {
    if (INFO.tabela) {
      console.log(INFO.tabela, 'INFO.tabela')
      if (INFO.tabela.headers) {
        INFO.tabela.headers = JSON.stringify(INFO.tabela.headers)
      }
      if (INFO.tabela.dados && INFO.tabela.uuid) {
        sessionStorage.setItem(INFO.tabela.uuid, JSON.stringify(INFO.tabela.dados))
        delete INFO.tabela.dados
      }
      if (INFO.tabela.categorias) {
        sessionStorage.setItem('categorias', JSON.stringify(INFO.tabela.categorias))
        INFO.tabela.categorias = true
      }
      if (INFO.tabela.tiposEstrutura) {
        sessionStorage.setItem('tiposEstrutura', JSON.stringify(INFO.tabela.tiposEstrutura))
        INFO.tabela.tiposEstrutura = true
      }
    }
    if (INFO.tabelaExtra) {
      if (INFO.tabelaExtra.headers) {
        INFO.tabelaExtra.headers = JSON.stringify(INFO.tabelaExtra.headers)
      }
      if (INFO.tabelaExtra.dados && INFO.tabelaExtra.uuid) {
        sessionStorage.setItem(INFO.tabelaExtra.uuid, JSON.stringify(INFO.tabelaExtra.dados))
        delete INFO.tabelaExtra.dados
      }
    }
    let query = Object.assign({},
      INFO.titulo ? { localPrint: INFO.titulo } : '',
      INFO.subtitulo ? { subtituloPrint: INFO.subtitulo } : '',
      INFO.landscape ? { landScapePrint: INFO.landscape } : '',
      INFO.isRelatorio ? { isRelatorioPrint: INFO.isRelatorio } : '',
      INFO.tabela ? { tabelaPrint: JSON.stringify(INFO.tabela) } : '',
      INFO.tabelaExtra ? { tabelaExtraPrint: JSON.stringify(INFO.tabelaExtra) } : ''
    )

    const routeData = self.$router.resolve({name: 'ExportPdf', query})
    window.open(routeData.href, '_blank')
  }
}

export default Export



// WEBPACK FOOTER //
// ./src/helper/export.js